import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import {FormErrorMessage} from '../../../ui-toolkit/forms/form-features/FormErrorMessage';

function MultilinePrimitiveFormatter({entity}) {
    if (_.isObject(entity)) {
        return <FormErrorMessage>{JSON.stringify(entity)}</FormErrorMessage>;
    }
    return <PreLine>{entity}</PreLine> || '-';
}

export const PreLine = styled.span`
    white-space: pre-wrap;
    word-break: break-word;
`;

export default MultilinePrimitiveFormatter;
